var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobilePhone = function SvgMobilePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.722 0 8.613.008c.947 0 1.722.728 1.722 1.628v14.728c0 .9-.775 1.636-1.722 1.636H1.722C.775 18 0 17.264 0 16.364V1.636C0 .736.775 0 1.722 0Zm0 16.225h8.613V2.275H1.722v13.95Zm2.991-1.8a.45.45 0 0 0 0 .9h2.89a.45.45 0 0 0 0-.9h-2.89Z",
    fill: "#D2AB67"
  })));
};
export default SvgMobilePhone;